import once from 'lodash.once';

import { withBasename } from 'utilities/url';

export type Configuration = {
  environment: 'local' | 'dev' | 'qa' | 'prod';
  api: {
    url: string | null;
  };
  auth: {
    clientId: string;
    issuer: string;
    callbackPath: string;
    serverPath: string;
    scope: string;
  };
  features: {
    analytics?: boolean;
    articleVoting?: boolean;
    userTelemetry?: boolean;
    userContextPulse?: boolean;
    allowThemes?: boolean;
    orgSwitcher?: boolean;
    newAppToolbar?: boolean;
    notifications?: boolean;
  };
};

let configuration: Configuration | undefined;

export const loadConfiguration = once(async () => {
  const response = await fetch(withBasename('configuration.json'), {
    headers: {
      'Content-Type': 'application/json'
    }
  });

  if (!response.ok) {
    throw new Error('Unable to load configuration');
  }

  configuration = await response.json();

  return configuration;
});

export const getConfig = () => {
  if (!configuration) {
    loadConfiguration();
  }

  return configuration;
};
